import timeOffInputStore from "../store/store";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_START_TIME', function setStartTimeInStore(startTime: Moment) {
    timeOffInputStore.startTime = startTime.clone();
});
